import { BaseProviderInstanceModel } from './base-provider-instance-model';

export class BaseProviderInstanceResourceModel extends BaseProviderInstanceModel {
  providerInstanceResourceId: string;
}
